import gql from 'graphql-tag'

export const GET_FLEET_STATUS = gql`
  query FleetStatus {
    fleetStatus {
      isSuccessful
      message
      fleetStatus {
        moving
        idle
        parked
        offline
      }
    }
  }
`

export const GET_FLEET_TOTALS_PER_DAY = gql`
  query FleetTotals($input: GetFleetTotalsInput!) {
    fleetTotals(input: $input) {
      isSuccessful
      message
      fleetTotals {
        totalDistance
        totalFuel
        totalMinutes
        day
      }
    }
  }
`

export const GET_TOP_20_VEHICLES = gql`
  query Top20vehicles($input: GetTop20VehiclesInput!) {
    top20vehicles(input: $input) {
      message
      top20Vehicles {
        licensePlate
        vehicleId
        type
        data
      }
    }
  }
`

export const GET_DASHBOARD_ALERT = gql`
  query DashboardAlert($filter: DashboardAlertFilter!) {
    dashboardAlert(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      dashboardAlert {
        alertCode
        alertData
        alertCount
        vehicleCount
      }
    }
  }
`

export const GET_SUMMARY_FUEL_COMPARISON = gql`
  query SummaryFuelDayComparison($filter: GetSummaryFuelDayComparisonFilter!) {
    summaryFuelDayComparison(filter: $filter) {
      isSuccessful
      message
      errorCode
      errorName
      status
      summaryFuelDayComparison {
        data {
          date
          sumActualEfficiency
          sumActualTotalFuel
          sumActualPrice
          sumTotalDistance
          sumStandardFuel
          sumStandardPrice
          sumTotalHours
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_MONTHLY_FUEL_COMPARISON = gql`
  query SummaryFuelMonthly($filter: GetSummaryFuelMonthlyFilter!) {
    summaryFuelMonthly(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryFuelMonthly {
        year
        month
        sumActualEfficiency
        sumActualTotalFuel
        sumActualPrice
        sumTotalDistance
        sumStandardPrice
        sumStandardFuel
        sumCountRefueling
        sumCountFuelLoss
        actualEfficiency {
          vehicleTypeId
          type
          manufacturer
          model
          category
          actualEfficiency
        }
      }
    }
  }
`

export const GET_FLEET_EFFICIENCY = gql`
  query VehicleTypeEfficiencyComparison($filter: GetVehicleTypeEfficiencyComparisonFilter!) {
    vehicleTypeEfficiencyComparison(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleTypeEfficiencyComparison {
        data {
          vehicleType {
            vehicleTypeId
            manufacturer
            model
            type
            category
          }
          totalVehicle
          totalInefficientVehicle
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_TRIPS_STATISTIC = gql`
  query TripsStatistic($filter: GetTripsStatisticFilter!) {
    tripsStatistic(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      tripsStatistic {
        totalVehicle
        avgSpeed {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        fuelPrice {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        fuelConsumption {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        fuelEfficiency {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        tripMileage {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        totalTrip {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        engineOnDuration {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        idleDuration {
          chosenValue
          compareValue
          increased
          diffValue
          diffPercent
        }
        driverViolation {
          summary {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          data {
            overSpeed {
              chosenValue
              compareValue
              increased
              diffValue
              diffPercent
            }
            harshAccel {
              chosenValue
              compareValue
              increased
              diffValue
              diffPercent
            }
            fuelAnomaly {
              chosenValue
              compareValue
              increased
              diffValue
              diffPercent
            }
          }
        }
      }
    }
  }
`

export const GET_TRIPS_STATISTICS = gql`
  query TripsStatistics($filter: GetTripsStatisticsFilter!) {
    tripsStatistics(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      tripsStatistics {
        data {
          month
          year
          totalVehicle
          utilizedVehicle {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          fuelPrice {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          fuelConsumption {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          tripMileage {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          totalTrip {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          avgSpeed {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          fuelEfficiency {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          engineOnDuration {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          idleDuration {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          idlePercentage {
            chosenValue
            compareValue
            increased
            diffValue
            diffPercent
          }
          driverViolation {
            summary {
              chosenValue
              compareValue
              increased
              diffValue
              diffPercent
            }
            data {
              overSpeed {
                chosenValue
                compareValue
                increased
                diffValue
                diffPercent
              }
              harshAccel {
                chosenValue
                compareValue
                increased
                diffValue
                diffPercent
              }
              fuelAnomaly {
                chosenValue
                compareValue
                increased
                diffValue
                diffPercent
              }
            }
          }
        }
        aggregate {
          top20TripMileage {
            vehicleId
            licensePlate
            mileage
          }
          top20FuelConsumption {
            vehicleId
            licensePlate
            fuelConsumption
          }
        }
      }
    }
  }
`

export const GET_LLM_REQUEST_HISTORY = gql`
  query GetRequestLlmMessageHistory($filter: GetRequestLlmMessageHistoryFilter) {
    getRequestLlmMessageHistory(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      getRequestLlmMessageHistory {
        data {
          users {
            fullname
          }
          contents
          filter
          createdOn
          type
        }
        dailyAttempt
        maxAttempt
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const REQUEST_LLM_MESSAGE = gql`
  mutation RequestLlmMessage($input: RequestLlmMessageInput!) {
    requestLlmMessage(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      requestLlmMessage {
        content {
          type
          text
        }
      }
    }
  }
`

export const SUMMARY_FUEL_DASHBOARD = gql`
  query SummaryFuelDashboard($filter: GetSummaryFuelDashboardFilter) {
    summaryFuelDashboard(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryFuelDashboard {
        data {
          date
          vehicle {
            id
            licensePlate
          }
          fuelConsumption
          distanceInKm
          idleDurationInSecond
          tripDurationInSecond
          fuelEfficiency
          driverAlert
          fuelTypePrice
        }
        total {
          fuelConsumption
          distanceInKm
          idleDurationInSecond
          tripDurationInSecond
          driverAlert
          fuelTypePrice
        }
      }
    }
  }
`
